import React from 'react';

const Nomatch = () => {
    return (
        <div>
            <h1>404...</h1>
            <h3>Route not found</h3>
        </div>
    );
};

export default Nomatch;